import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { setCurrentTab } from 'redux/actions/TabActions';
import CommonTable from 'components/commonTable/CommonTable';
import LocationDropdown from 'components/LocationDropdown/LocationDropdown';
import CommonSDF from 'components/commonSDF/CommonSdf';
import Loader from 'components/loader/Loader';
import { moreIconActions } from './RideTrackData';

const RideTrackTab = (props) => {
  const dispatch = useDispatch();
  const currentTab = useSelector(state => state?.rideTrack?.currentTab);
  const navigate = useNavigate();

  // Sync Redux state with props.value when component mounts or value changes
  useEffect(() => {
    if (props.value && props.value !== currentTab) {
      dispatch(setCurrentTab(props.value));
    }
  }, [props.value]);

  // Use props.value if available, fallback to currentTab
  const activeTab = props.value || currentTab || '1';

  const handleChange = (event, newValue) => {
    navigate(`/rideTrack/${newValue}`);
    dispatch(setCurrentTab(newValue));
    props?.handleChange?.(newValue);
  };

  const handleChangePage = (event, newPage) => {
    props?.handleChangePage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    props?.handleChangeRowsPerPage(event);
  };

  const onClickTableVendor = (data) => {
    props?.onClickTableVendor(data);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={activeTab}>
        {/* Simple Tab List */}
        <Box className="tabBoxStyle contentBoxStyle" sx={{
          borderBottom: '1px solid #e0e0e0',
          mb: 3,
          px: 2 
        }}>
          <TabList
            onChange={handleChange}
            aria-label="ride track tabs"

          >
            <Tab label="Ride" value="1" className="tabStyle" />
            <Tab label="Rental" value="3" className="tabStyle" />
            <Tab label="Airport" value="4" className="tabStyle" />
            <Tab label="Outstation" value="9" className="tabStyle" />
          </TabList>
        </Box>

        {/* Filters Row */}
        <Box
          sx={{
            display: 'flex',
            flexDirection:{lg:'row',md:'row',sm:'column',xs:'column'},
            // alignItems: 'center',
            justifyContent:{lg:'flex-end',md:'flex-end',sm:'flex-start',xs:'flex-start'},
            gap: 2,
            mb: 3,
            px: 1
          }}
        >
          {/* City Dropdown - Fixed width */}
          <Box sx={{ width: '200px' }}>
            <LocationDropdown
              onChange={props?.onInputChange}
              placeholder="All City"
              fullWidth
            />
          </Box>

          {/* Search & Filters - Takes remaining space */}
          <Box sx={{
            flex: 1,
            display: 'flex',
            // alignItems: 'center',
          }}>
            <CommonSDF
              onSearch={props?.onSearch}
              searchValue={props?.searchValue}
              filterdata={props?.filterData}
              onFilterChange={props?.onFilterChange}
              onRestFilter={props?.onRestFilter}
              defaultStatus={props.defaultStatus}
              onSelectDateRange={props?.onSelectDateRange}
              tabName={props?.tabName}
              dateFrom={props?.dateFrom}
              dateTo={props?.dateTo}
            />
          </Box>
        </Box>

        {/* Table Content */}
        <TabPanel value={activeTab} sx={{ p: 0 }}>
          {props?.loader ? (
            <Loader />
          ) : (
            <CommonTable
              data={props?.rideTrackData}
              onClickTableVendor={onClickTableVendor}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              page={props?.page}
              rowsPerPage={props?.rowsPerPage}
              isClickable={true}
              tabName={props?.tabName}
              moreIconData={moreIconActions}
              onClickMoreIcon={props.onClickMoreIcon}
              viewMoreIcon={false}
            />
          )}
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default RideTrackTab;